import styled from "styled-components";
import { Breakpoints } from "styles/breakpoints";
import colours from "styles/colours";
import fonts, { fontWeights } from "styles/fonts";

export const StyledColumnTitle = styled.div`
  font-weight: ${fontWeights.heavy};
  text-transform: uppercase;
  letter-spacing: 0.15em;
  margin-left: 1.2em;
  margin-bottom: 1em;

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover,
  a:focus {
    text-decoration: underline;
  }

  @media (max-width: ${Breakpoints.Small}) {
    text-transform: capitalize;
    font-size: ${fonts.small};
    letter-spacing: 0.15em;
    font-weight: ${fontWeights.normal};
    margin-left: 16px;

    a {
      color: ${colours.white};
    }
  }
`;
